<template>
  <div class="icon-link">
    <img :src="imgUrl" :alt="alt">
    <a @click="$emit('open')" :href="url" :title="title"><slot /></a>
  </div>
</template>

<script>
  export default {
    name: 'iconlink',

    props: {
      url: String,
      img: String,
      alt: String,
      title: String
    },

    computed: {
      imgUrl() {
        return `https://s3.amazonaws.com/s3.pilates.com/contrology/${ this.img }`;
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon-link {
  margin: 20px 0;
}

a {
  font-family: var(--roboto);
  font-size: 0.9rem;
  line-height: 1.25;
  font-weight: 400;
  color: var(--black);
  text-decoration: none;
  cursor: initial;
}

a[href]:hover {
  text-decoration: underline;
  cursor: pointer;
}

a[title~="modal"] {
  cursor: pointer;
}

a[title~="modal"]:hover {
  text-decoration: underline;
}

img {
  margin-right: 10px;
  margin-bottom: -3px;
  width: 20px;
}

@media only screen and (min-width:768px) {
  .icon-link {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  a {
    font-size: 0.75rem;
  }

  img {
    padding: 5px 0;
    margin-bottom: 0;
    width: 15px;
  }
}
</style>